import { Pipe, PipeTransform } from '@angular/core';
import { FileDto } from 'src/app/models/FileDto';

@Pipe({
  name: 'filenameFilter',
  standalone: true
})
export class FileNameFilterPipe implements PipeTransform {
  /**
   * Filters an array of files based on a search term.
   * The search term is matched against the file's original name.
   *
   * @param {FileDto[]} files - The array of files to filter.
   * @param {string} searchTerm - The term to search for in the file names.
   * @returns {FileDto[]} - The filtered array of files.
   */
  transform(files: FileDto[], searchTerm: string): FileDto[] {
    // Check if files or searchTerm are not provided
    if (!files || !searchTerm) {
      return files;
    }

    // Convert the search term to lowercase for case-insensitive comparison
    const lowerSearchTerm = searchTerm.toLowerCase();

    // Filter the files array based on the search term
    return files.filter((file) =>
      // Check if the original name includes the search term
      file.originalname.toLowerCase().includes(lowerSearchTerm)
    );
  }
}
